module.exports = __webpack_public_path__ + "static/img/agent_tit_icon.2bb7097f.png";